import React, { Component } from 'react';

import { COLOR, FONT_FAMILY } from './constants/styles';
import { Platform, Keyboard } from 'react-native';
import Navigation from './navigation';
import I18n from './I18n.js';

const ISANDROID = Platform.OS === 'android';

const HIDDEN_NAVBAR_STYLES = {
  visible: false,
  drawBehind: true,
};

const AUTH_STATUS_BAR_STYLES = {
  style: 'light',
  drawBehind: true,
  backgroundColor: 'transparent',
};

const AUTH_NAVBAR_STYLES = {
  background: {
    color: 'transparent',
  },
  drawBehind: true,
  title: {
    color: COLOR.darkTheme.text,
  },
  backButton: {
    title: '', // Remove previous screen name from back button
    color: COLOR.darkTheme.text,
  },
  buttonColor: COLOR.darkTheme.text,
  elevation: 0,
};

const BASE_NAVBAR_STYLES = {
  background: {
    color: 'white',
  },
  drawBehind: false,
  title: {
    color: COLOR.textLight,
    fontSize: 16,
    // fontFamily: FONT_FAMILY.bold,
    fontWeight: 'normal',
  },
  backButton: {
    title: '', // Remove previous screen name from back button
    color: COLOR.button,
  },
  buttonColor: COLOR.button,
};

const ANDROID_CANCEL = {
  id: 'cancel',
  icon: require('../resources/android-navbar-cancel.png'),
};

const BUTTONS = {
  cancel: ISANDROID
    ? ANDROID_CANCEL
    : {
        text: I18n.t('cancel'),
        id: 'cancel',
      },
  close: ISANDROID
    ? ANDROID_CANCEL
    : {
        text: I18n.t('cancel'),
        id: 'cancel',
      },
  done: ISANDROID
    ? ANDROID_CANCEL
    : {
        text: I18n.t('done'),
        id: 'cancel',
      },
  sidebar: {
    id: 'sidebar',
    testID: 'sidebar',
    icon: require('../resources/menu.png'),
  },
  // invite: {
  //   id: 'main_invite',
  //   component: {
  //     name: 'MainInviteNavbarButton',
  //   },
  // },
  broadcast: {
    id: 'main_broadcast',
    component: {
      name: 'MainBroadcastNavbarButton',
    },
  },
  notifications: {
    id: 'main_notifications',
    component: {
      name: 'NotificationsNavbarButton',
    },
  },
  profile: {
    id: 'main_profile',
    component: {
      name: 'ProfileMenuNavbarButton',
    },
  },
  setCaseCalendarScreen: {
    id: 'select_case',
    component: {
      name: 'SelectCaseCalendarScreenNavbarButton',
    },
  },
  navBarTitle: {
    id: 'employer_navbar_title',
    component: {
      name: 'EmployerHomeNavBarTitle',
    },
  },
  save: {
    text: I18n.c1('save'),
    id: 'save',
  },
  upload: {
    text: I18n.c1('upload'),
    id: 'save',
  },
  edit: {
    text: I18n.t('edit'),
    id: 'edit',
  },
};

const _close = function (options) {
  // console.info('NavBar _close, ', options);
  Navigation.close(options);
};

const NavBar = {
  navigatorStyle: { ...BASE_NAVBAR_STYLES },
  hiddenNavbarStyle: { ...HIDDEN_NAVBAR_STYLES },
  authNavbarStyle: { ...AUTH_NAVBAR_STYLES },
  authStatusBarStyle: { ...AUTH_STATUS_BAR_STYLES },

  buttons: BUTTONS,

  milStaffButtons: ISANDROID
    ? {
        leftButtons: [BUTTONS.sidebar],
        rightButtons: [BUTTONS.profile, BUTTONS.notifications, BUTTONS.broadcast],
      }
    : {
        leftButtons: [BUTTONS.sidebar],
        rightButtons: [BUTTONS.profile, BUTTONS.notifications, BUTTONS.broadcast],
      },

  milPatientButtons: ISANDROID
    ? {
        leftButtons: [BUTTONS.sidebar],
        rightButtons: [BUTTONS.profile, BUTTONS.notifications],
      }
    : {
        leftButtons: [BUTTONS.sidebar],
        rightButtons: [BUTTONS.profile, BUTTONS.notifications],
      },

  consumerButtons: ISANDROID
    ? {
        leftButtons: [BUTTONS.sidebar],
        rightButtons: [BUTTONS.profile, BUTTONS.notifications, BUTTONS.navBarTitle],
      }
    : {
        leftButtons: [BUTTONS.sidebar, BUTTONS.navBarTitle],
        rightButtons: [BUTTONS.profile, BUTTONS.notifications],
      },

  medRecruiterButtons: ISANDROID
    ? {
        leftButtons: [BUTTONS.sidebar],
        rightButtons: [BUTTONS.profile, BUTTONS.notifications],
      }
    : {
        leftButtons: [BUTTONS.sidebar],
        rightButtons: [BUTTONS.profile, BUTTONS.notifications],
      },

  navbarButtonPressHandlers: {
    sidebar: ({ componentId }) => {
      Navigation.openDrawer(componentId);
      return true;
    },
    close_modal: (options) => {
      _close(options);
      return true;
    },
    cancel: (options) => {
      options?.onCancel && options.onCancel();
      _close(options);
      return true;
    },
    // backPress is a built in event.id (included in react-native-navigation)
    backPress: (options) => {
      options?.onCancel && options.onCancel();
      _close(options);
      return true;
    },
    save: (options) => {
      const onSave = options && options['onSave'];
      onSave && onSave();
      return !!onSave;
    },
    edit: (options) => {
      const onEdit = options && options['onEdit'];
      onEdit && onEdit();
      return !!onEdit;
    },
  },

  // options: asModal, noBacksies
  handleButtonPress(componentId, buttonId, options = null) {
    // this and handleButtonPress2 are called by navigationButtonPressed
    // which is a special react-native-navigation hook for whenever the top tabbars
    // has a button pushed
    Keyboard.dismiss();
    let handle = this.navbarButtonPressHandlers[buttonId];
    if (handle) {
      handle = handle.bind(this);
      return handle({
        ...options,
        componentId,
      });
    }
  },

  handleButtonPress2(buttonId, compRef) {
    // console.info(
    //   'handleButtonPress2',
    //   compRef.props.componentId,
    //   compRef.props.asModal,
    //   buttonId
    // );

    const { componentId, asModal, noBacksies } = compRef.props;
    return this.handleButtonPress(componentId, buttonId, {
      onSave: compRef.onSave,
      onEdit: compRef.onEdit,
      asModal,
      noBacksies,
    });
  },

  setup(props, options, routeName) {
    return function () {
      if (!options) options = {};

      if (options.style) Navigation.setStyle(options.style, props.componentId);
      if (options.title) Navigation.setTitle(options, props.componentId);
      const listeners = {
        navigationButtonPressed: function ({ buttonId }) {
          if (
            NavBar.handleButtonPress(props.componentId, buttonId, {
              asModal: props.asModal,
              ...options,
            })
          )
            return;
        },
        ...(options.listeners || {}),
      };
      Navigation.registerForButtonEvents(listeners, props, routeName);
      if (options.buttons) Navigation.setButtons(options.buttons, props.componentId);
      return () => {
        Navigation.unRegisterForButtonEvents(listeners);
      };
    };
  },
};

module.exports = NavBar;
